import React, { useEffect, useState } from "react";
import { useBoolean } from "@fluentui/react-hooks";
import i18n from "i18next";
import { fetchWrapper } from "../../../helpers/fetchwrapper";

import {
  createTableColumn,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  TableColumnDefinition,
  Link,
  Field,
  Input,
  Checkbox,
  Label,
} from "@fluentui/react-components";
// Eigene Imports
import { baseUrl } from "../../../helpers/constants";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import { Button } from "@fluentui/react-components";
import {
  ArrowSwapRegular,
  CheckmarkRegular,
  DeveloperBoardSearchRegular,
  DismissRegular,
  EmojiLaughRegular,
  EmojiSmileSlightRegular,
  SearchRegular,
} from "@fluentui/react-icons";
import { IUserRoleRequest } from "../../../Models/IUserRoleRequest";
import LuebPagedDataGrid from "../../../Controls/LuebPagedDataGrid";
import Header from "../../Layout/Header";

function RoleRequests(props: any) {
  const [toolboxStattPartnerId, setToolboxStattPartnerId] = useState<
    string | undefined
  >(undefined);
  const [partnerStattToolboxId, setPartnerStattToolboxId] = useState<
    string | undefined
  >(undefined);
  const [showClosed, setShowClosed] = useState(false);
  const [eMail, setEMail] = useState("");

  const [grayRows, setGrayRows] = useState<number[]>([]);

  const [roleRequests, setRoleRequests] = useState<IUserRoleRequest[]>([]);

  const getRequests = () => {
    fetchWrapper
      .getWithAuth(
        `${baseUrl}/api/vertrieb/GetRequestedRoles?showClosed=${showClosed}&email=${eMail}`,
      )
      .then((data: IUserRoleRequest[]) => {
        setRoleRequests(data);
      });
  };

  const toolboxStattPartner = (guid: string) => {
    fetchWrapper
      .getWithAuth(baseUrl + "/api/vertrieb/ToolboxStattPartner?guid=" + guid)
      .then(() => {
        setToolboxStattPartnerId(undefined);
        getRequests();
      });
  };

  const partnerStattToolbox = (guid: string) => {
    fetchWrapper
      .getWithAuth(baseUrl + "/api/vertrieb/PartnerStattToolbox?guid=" + guid)
      .then(() => {
        setPartnerStattToolboxId(undefined);
        getRequests();
      });
  };

  const acceptRequest = (guid: string) => {
    fetchWrapper
      .getWithAuth(baseUrl + "/api/vertrieb/AcceptRequestedRole?guid=" + guid)
      .then(() => {
        getRequests();
      });
  };

  const declineRequest = (guid: string) => {
    fetchWrapper
      .getWithAuth(baseUrl + "/api/vertrieb/DeclineRequestedRole?guid=" + guid)
      .then(() => {
        getRequests();
      });
  };
  useEffect(() => {
    roleRequests.forEach((x) => {
      if (x.accepted || x.declined) {
        grayRows.push(roleRequests.indexOf(x));
      }
    });
  }, [roleRequests]);
  useEffect(() => {
    getRequests();
    /* const interval = setInterval(() => {
      getRequests();
    }, 30000);
    return () => clearInterval(interval); */
  }, []);
  const columns: TableColumnDefinition<IUserRoleRequest>[] = [
    createTableColumn<IUserRoleRequest>({
      columnId: "benutzerEmailId",
      compare: (a, b) => {
        if (a.appUser.email && b.appUser.email) {
          return a.appUser.email.localeCompare(b.appUser.email);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("user");
      },
      renderCell: (item) => {
        return (
          <>
            <Link
              href={
                window.location.origin + "/sales/users?guid=" + item.appUser.id
              }
              target="_blank"
            >
              {item.appUser.email}
            </Link>
            <div style={{ marginLeft: "5px" }}>
              {item.appUser.emailConfirmed && (
                <CheckmarkRegular color="green" />
              )}
              {!item.appUser.emailConfirmed && <DismissRegular color="red" />}
            </div>
          </>
        );
      },
    }),
    createTableColumn<IUserRoleRequest>({
      columnId: "requestedRoleId",
      compare: (a, b) => {
        if (a.requestedRole && b.requestedRole) {
          return a.requestedRole.localeCompare(b.requestedRole);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("requestedRole");
      },
      renderCell: (item) => {
        return item.requestedRole;
      },
    }),
    createTableColumn<IUserRoleRequest>({
      columnId: "requestDateId",
      compare: (a, b) => {
        if (a.requestedDate && b.requestedDate) {
          return a.requestedDate.localeCompare(b.requestedDate);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("date");
      },
      renderCell: (item) => {
        return new Date(item.requestedDate).toLocaleString();
      },
    }),

    createTableColumn<IUserRoleRequest>({
      columnId: "statusId",
      renderHeaderCell: () => {
        return i18n.t<string>("status");
      },
      renderCell: (item) => {
        return (
          <>
            {!item.accepted && !item.declined && (
              <>
                <Button
                  appearance="transparent"
                  icon={<CheckmarkRegular color="green" />}
                  onClick={() => {
                    acceptRequest(item.guid);
                  }}
                >
                  {i18n.t<string>("accept")}
                </Button>
                <Button
                  appearance="transparent"
                  icon={<DismissRegular color="red" />}
                  onClick={() => {
                    declineRequest(item.guid);
                  }}
                >
                  {i18n.t<string>("decline")}
                </Button>
                {item.requestedRole.toLowerCase() == "toolbox" && (
                  <Button
                    appearance="transparent"
                    icon={<ArrowSwapRegular />}
                    onClick={() => {
                      setPartnerStattToolboxId(item.guid);
                    }}
                  >
                    Partner statt Toolbox
                  </Button>
                )}
                {item.requestedRole.toLowerCase() == "partner" && (
                  <Button
                    appearance="transparent"
                    icon={<ArrowSwapRegular />}
                    onClick={() => {
                      setToolboxStattPartnerId(item.guid);
                    }}
                  >
                    Toolbox statt Partner
                  </Button>
                )}
              </>
            )}

            {(item.accepted || item.declined) && (
              <Label style={{ color: item.accepted ? "green" : "red" }}>
                {item.accepted ? "Akzeptiert" : "Abgelehnt"}
              </Label>
            )}
          </>
        );
      },
    }),
  ];

  return (
    <div>
      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            <Button
              icon={
                <DeveloperBoardSearchRegular fontSize={24} color="#ff6600" />
              }
              size="large"
              appearance="subtle"
            >
              {i18n.t<string>("roleRequests").toLocaleUpperCase()}
            </Button>
          </StackShim>
        }
      />

      <Dialog
        open={
          toolboxStattPartnerId != undefined ||
          partnerStattToolboxId != undefined
        }
      >
        <DialogSurface>
          <DialogBody>
            <DialogTitle>
              {toolboxStattPartnerId && <div>Toolbox statt Partner Lounge</div>}
              {partnerStattToolboxId && <div>Partner Lounge statt Toolbox</div>}
            </DialogTitle>
            <DialogContent>
              {toolboxStattPartnerId && (
                <div>
                  Dem Benutzer die Rolle Toolbox statt Partner Lounge zuweisen?
                </div>
              )}
              {partnerStattToolboxId && (
                <div>
                  Dem Benutzer die Rolle Partner Lounge statt Toolbox zuweisen?
                </div>
              )}
            </DialogContent>
            <DialogActions>
              <Button
                appearance="primary"
                onClick={() => {
                  if (toolboxStattPartnerId) {
                    toolboxStattPartner(toolboxStattPartnerId);
                  }
                  if (partnerStattToolboxId) {
                    partnerStattToolbox(partnerStattToolboxId);
                  }
                }}
              >
                {i18n.t<string>("accept")}
              </Button>
              <Button
                onClick={() => {
                  setPartnerStattToolboxId("");
                  setToolboxStattPartnerId("");
                }}
              >
                {i18n.t<string>("cancel")}
              </Button>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
      <div className="lueb-ContentBlock">
        <Field label="E-Mail">
          <Input
            onKeyDown={(data) => {
              if (data.key == "Enter") {
                getRequests();
              }
            }}
            placeholder="Nach Mailadresse suchen"
            value={eMail}
            onChange={(ev, data) => {
              setEMail(data.value ? data.value : "");
            }}
          />
        </Field>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Checkbox
            label="Erledigte anzeigen"
            checked={showClosed}
            onChange={(ev, checked) => {
              if (typeof checked.checked == "boolean") {
                setShowClosed(checked.checked);
              }
            }}
          />
          <Button
            icon={<SearchRegular />}
            appearance="primary"
            onClick={() => getRequests()}
          >
            {i18n.t<string>("search")}
          </Button>
        </div>
      </div>

      <div className="lueb-ContentBlock">
        <div className="lueb-Padding20">
          {roleRequests.length > 0 && (
            <LuebPagedDataGrid
              sortable
              columns={columns}
              items={roleRequests}
              resizableColumns={true}
              columnSizingOptions={{
                benutzerEmailId: { defaultWidth: 200, minWidth: 100 },
                requestDateId: { defaultWidth: 160, minWidth: 90 },
                requestedRoleId: { defaultWidth: 130, minWidth: 90 },
              }}
            />
          )}
          {roleRequests.length == 0 && (
            <div>
              <div className="lueb-padding5 lueb-MarginTopBottom10">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-around",
                    alignItems: "center",
                    height: "115px",
                  }}
                >
                  {!eMail && (
                    <>
                      <EmojiLaughRegular fontSize={70} color="#ff6600" />
                      <Label>
                        Yippiiee, keine weiteren Modul-Anfragen offen!
                      </Label>
                    </>
                  )}
                  {eMail && (
                    <>
                      <EmojiSmileSlightRegular fontSize={70} color="#ff6600" />
                      <Label>
                        Unter dieser Mail gibt es keine Modul-Anfragen
                      </Label>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default RoleRequests;
